import React, { ReactElement, useState, useEffect } from 'react';
import className from 'classnames/bind';
import { connect } from 'react-redux';
import styles from './index.pcss';
import { showModal } from '../../../../actions/shared/modal';
import properties from '../../../../modules/ajio-util/properties';
import { calculateDifferenceFromToday } from '../../../utils/dateUtils';
import { fetchMarkAsHelpful } from '../../../../actions/ratings';
import { signInCheck } from '../../../../components/common/CheckUserStatus';
import { gtmEventPush, segmentEventPush } from '../../../../modules/ga/GTMdatalayer';
import { getRatingsColorConfig } from '../../../selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';

const cx = className.bind(styles);
const imgPath = `${properties.getProperty('assetUrl')}/static`;

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => dispatch(showModal(name, config)),
    fetchMarkAsHelpful: (reviewId: string) => dispatch(fetchMarkAsHelpful({ reviewId }))
  };
};
const mapStateToProps = state => ({
  ratingsColor: getRatingsColorConfig(state?.flags)
});

const connector = connect(mapStateToProps, mapDispatchToProps);
const ReviewDetailsDesktop = ({
  reviewData,
  fetchMarkAsHelpful,
  single,
  currentIndex,
  updateSelectedImageIndex,
  renderSinglePhotoModal,
  productDetails = {},
  ratingsColor = {}
}: {}): ReactElement => {
  const {
    rating,
    reviewId,
    reviewText,
    reviewerName,
    isVerified,
    helpfulContent,
    createdDate,
    imageMap
  } = reviewData;
  const [heplfulCount, setHelpfulCount] = useState(helpfulContent);
  const [isMarkedAsHelpful, setIsMarkedAsHelpful] = useState(false);
  const postedDays = calculateDifferenceFromToday(Number(createdDate));
  const { productId, productName, productBrick } = productDetails;

  const triggerAPIForMarkAsHelpFull = async () => {
    const response = await fetchMarkAsHelpful(reviewId);
    setHelpfulCount(initial => initial + 1);
    setIsMarkedAsHelpful(true);
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'Mark as helpful',
      event_label: reviewId,
      ...(productId.length > 0 && { product_id: productId }),
      ...(productName.length > 0 && { product_name: productName }),
      ...(productBrick.length > 0 && { product_brick: productBrick }),
      pageType: 'PDP',
      store_type: 'ajio'
    });    
    // Segment Push event
    segmentEventPush({
      event: 'Review Widget Interaction',
      event_category: 'reviews_rating_interactions',
      event_action: 'Mark as helpful',
      event_label: reviewId,
      products:[{
          ...(productId.length > 0 && { product_id: productId }),
          ...(productName.length > 0 && { product_name: productName }),
          ...(productBrick.length > 0 && { product_brick: productBrick }),
          product_brand: '',
          product_list_price: '',
          product_mrp: '',
          product_offer_price: '',
          product_rating: '',
          product_segment: '',
          product_vertical: '',
          screen_name: ''
      }],
      // pageType: 'PDP',
      store_type: 'ajio'
    });
  };

  useEffect(() => {
    const isSignedIn = signInCheck();
    const reviewToSetMarkAsHelpful = localStorage.getItem('setMarkAsHelpful');
    if (reviewToSetMarkAsHelpful && reviewToSetMarkAsHelpful == reviewId && isSignedIn) {
      triggerAPIForMarkAsHelpFull();
      localStorage.removeItem('setMarkAsHelpful');
    }
  }, [reviewId]);

  const handleMarkAsHelpfulClick = async () => {
    const isSignedIn = signInCheck();
    if (isSignedIn) {
      triggerAPIForMarkAsHelpFull();
    } else {
      localStorage.setItem('setMarkAsHelpful', reviewId);
      window.location.href = `/login?referrer=${window.location.pathname}`;
    }
  };

  const imageClickHandler = i => {
    updateSelectedImageIndex(i);
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'review photos - viewed',
      event_label: reviewId,
      ...(productId.length > 0 && { product_id: productId }),
      ...(productName.length > 0 && { product_name: productName }),
      ...(productBrick.length > 0 && { product_brick: productBrick }),
      pageType: 'PDP',
      store_type: 'ajio'
    });
    // Segment Push event
    segmentEventPush({
      event: 'Review Widget Interaction',
      event_category: 'reviews_rating_interactions',
      event_action: 'review photos - viewed',
      event_label: reviewId,
      products:[{
          ...(productId.length > 0 && { product_id: productId }),
          ...(productName.length > 0 && { product_name: productName }),
          ...(productBrick.length > 0 && { product_brick: productBrick }),
          product_brand: '',
          product_list_price: '',
          product_mrp: '',
          product_offer_price: '',
          product_rating: '',
          product_segment: '',
          product_vertical: '',
          screen_name: ''
      }],
      // pageType: 'PDP',
      store_type: 'ajio'
    });
    
  };

  const {
    thresholdValue = 3,
    ratingBelowThresholdColor = '',
    ratingAboveThresholdColor = ''
  } = ratingsColor;

  return (
    <>
      <div className={cx('reviews-details-container-web')}>
        <div className={cx('reviews-details-left')}>
          <div
            className={cx(
              'reviews-details-ratings-box-web',
              rating < 3 ? 'reviews-details-ratings-box-red' : 'reviews-details-ratings-box-green'
            )}
            style={{
              backgroundColor: rating < thresholdValue ? ratingBelowThresholdColor : ratingAboveThresholdColor
            }}
          >
            <span className={cx('reviews-details-rating-number-web')}>
              <strong>{rating}</strong>
            </span>
            <img
              className={cx('reviews-details-rating-img-web')}
              src={`${imgPath}/img/rating-star.svg`}
              alt="Star icon"
              onError={e => (e.target.src = '/img/rating-star.svg')}
            />
          </div>
        </div>
        <div className={cx('reviews-details-right-web')}>
          <div className={cx('reviews-details-text-web')}>{reviewText}</div>
          {imageMap?.thumbnail?.length > 0 && !single && (
            <div className={cx('reviews-details-images-container-web')}>
              {imageMap.thumbnail.map((el, i) => {
                const imgUrl = el.imageUrl || '';
                return (
                  <div
                    className={cx('reviews-details-images-web')}
                    onClick={() => renderSinglePhotoModal(reviewData, i)}
                  >
                    <img
                      className={cx('reviews-details-images-web-img')}
                      src={`${replaceWithJioCDN(imgUrl)}`}
                      alt="Customer product image"
                    />
                  </div>
                );
              })}
            </div>
          )}
          <div className={cx(single ? 'reviews-details-bottom-vert' : 'reviews-details-bottom')}>
            <div className={cx('reviews-details-bottom-left')}>
              <div className={cx('reviews-details-customer')}>
                <div className={cx('reviews-details-customer-name-web')}>
                  <strong>{reviewerName}</strong>
                </div>
                {isVerified && (
                  <>
                    <div className={cx('reviews-details-divider')}> | </div>
                    <img
                      className={cx('reviews-details-review-verified-img')}
                      src={`${imgPath}/img/review-verified.svg`}
                      alt="Tick icon"
                      onError={e => (e.target.src = '/img/review-verified.svg')}
                    />
                    <div className={cx('reviews-details-customer-verified-web')}>
                      Verified Purchase
                    </div>
                  </>
                )}
              </div>
              <span className={cx('reviews-details-posted-web')}>{postedDays}</span>
            </div>
            {imageMap?.thumbnail?.length > 0 && single && (
              <div className={cx('reviews-details-images-container-web-vert')}>
                {imageMap.thumbnail.map((el, i) => {
                  const imgUrl = el.imageUrl || '';
                  return (
                    <div
                      className={cx(
                        'reviews-details-images-web',
                        currentIndex != -1 && currentIndex === i
                          ? 'reviews-details-images-web-border'
                          : ''
                      )}
                      onClick={() => imageClickHandler(i)}
                    >
                      <img
                        className={cx('reviews-details-images-web-img')}
                        src={`${replaceWithJioCDN(imgUrl)}`}
                        alt="Customer product image"
                      />
                    </div>
                  );
                })}
              </div>
            )}
            <div className={cx('reviews-details-bottom-right')}>
              <div className={cx('reviews-details-footer')}>
                <div className={cx('reviews-details-helpful-text')}>
                  <b>{heplfulCount}</b>
                  <span className={cx('reviews-details-helpful-text2-web')}>
                    People found this helpful
                  </span>
                </div>
                {!isMarkedAsHelpful ? (
                  <div
                    className={cx('reviews-details-helpful-container-web')}
                    onClick={handleMarkAsHelpfulClick}
                  >
                    <img
                      className={cx('reviews-details-hand-img')}
                      src={`${imgPath}/img/hand_grey.svg`}
                      onError={e => (e.target.src = '/img/hand_grey.svg')}
                      alt="Thumbs up unselected icon"
                    />
                    <span className={cx('reviews-details-helpful-buttontext-web')}>
                      Mark as helpful
                    </span>
                  </div>
                ) : (
                  <div className={cx('reviews-details-helpful-container2-web')}>
                    <img
                      className={cx('reviews-details-hand-img')}
                      src={`${imgPath}/img/hand_green.svg`}
                      alt="Thumbs up selected icon"
                      onError={e => (e.target.src = '/img/hand_green.svg')}
                    />
                    <span className={cx('reviews-details-helpful-buttontext2-web')}>
                      Marked as helpful
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connector(ReviewDetailsDesktop);
